import {Pipe, PipeTransform} from '@angular/core';
import {Moment} from 'moment';

/**
 * This pipe transforms date in a specific format.
 */
@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {

  /**
   * Transforms date from Moment to string, formatted in a given format.
   * @param value date value in Moment.
   * @param format a format in which the date should be transformed.
   */
  transform(value: Moment, format: string) {
    if (!value) {
      return;
    }

    return value.format(format);
  }
}
